export const useNavigationContextStore = defineStore('navigationContext', {
  state: () => ({
    context: null, // 'collection', 'playlist', or null
    sourceId: null, // collection slug or playlist slug
    sourceTitle: null, // collection title or playlist name
    rudiments: [], // list of rudiments in current context
  }),

  actions: {
    setCollectionContext(collectionSlug, collectionTitle, rudiments) {
      this.context = 'collection'
      this.sourceId = collectionSlug
      this.sourceTitle = collectionTitle
      this.rudiments = rudiments || []
    },

    setPlaylistContext(playlistSlug, playlistTitle, rudiments) {
      this.context = 'playlist'
      this.sourceId = playlistSlug
      this.sourceTitle = playlistTitle
      this.rudiments = rudiments || []
    },

    clearContext() {
      this.context = null
      this.sourceId = null
      this.sourceTitle = null
      this.rudiments = []
    },

    updateRudiments(rudiments) {
      this.rudiments = rudiments || []
    }
  },

  getters: {
    hasContext: (state) => state.context !== null,
    isCollection: (state) => state.context === 'collection',
    isPlaylist: (state) => state.context === 'playlist',
    getSourceUrl: (state) => {
      if (state.context === 'collection') {
        return `/play/collection/${state.sourceId}`
      } else if (state.context === 'playlist') {
        return `/play/playlists/${state.sourceId}`
      }
      return null
    }
  }
})